import React, { Component } from 'react';
import styled from 'styled-components';
import preloader from '../preload';
import header from '../assets/header.png';
import { ThemeProvider } from 'styled-components';
import { Form } from '../dooh-react-utils';

const FIELDS = [{ name: 'age', label: 'Godine', type: 'age' }];

const Wrap = styled.div`
  #bg, #overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 1080px;
    height: 1920px;
  }

  #bg {
    pointer-events: none;
  }

  #overlay {
    background: #8af1a4 url('${preloader.get(header)}') no-repeat 50% 50px;
  }

  text-align: center;

  h1 {
    margin-top: 260px;
    font-size: 80px;
    font-family: Gagalin-Regular;
    margin-bottom: 80px;
  }
`;

const THEME = {
  //#ffd92a
  keyboardBackgroundColor: '#3ca445',
  buttonBackground: '#3ca445',
  keyboardTextColor: 'white',
  buttonTextColor: 'white',
  checkboxInnerColor: '#4F4F51',
  checkboxOuterColor: 'white',
  termsLineColor: 'white',
  checkboxInvert: false,
  buttonUppercase: false,
  inputFont: 'RalewayBold',
  font: 'RalewayBold',
  termsBackground: 'rgba(236,29,35,1)',
};

function videoTimeUpdate(e) {
  let video = e.target;
  if (video.currentTime >= 6) {
    video.currentTime = 0;
    video.play();
  }
}

class Screen extends Component {
  render() {
    return (
      <Wrap>
        <div id="overlay">
          <h1>
            Prije početka, upiši
            <br />
            koliko imaš godina:
          </h1>
          <ThemeProvider theme={THEME}>
            <Form
              fields={FIELDS}
              skip={() => {
                window.track('skip');
                this.props.gotoNextScreen();
              }}
              onSubmit={data => {
                this.props.update({ age: data.age });
                window.track('age', data);
                this.props.gotoNextScreen();
              }}
            />
          </ThemeProvider>
        </div>

        <video
          id="bg"
          onTimeUpdate={videoTimeUpdate}
          src={preloader.get(require('../assets/bubble.webm'))}
          muted
          autoPlay
          loop
        />
      </Wrap>
    );
  }
}

export default Screen;
